// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ChevronUp: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="m21.492 16.122-1.063 1.064-8.244-8.245-8.245 8.245-1.063-1.064 9.308-9.308 9.307 9.308Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export const ChevronUpOffset: IconOffset = {
    vertical: 28, // Store Custom Code
    horizontal: 10, // Store Custom Code
};

export default React.memo(ChevronUp);
